"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  return state;
};

var initialState = {};
//# sourceMappingURL=s3Reducer.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/s3/s3Reducer.js
// module id = 254
// module chunks = 0